module.exports = __webpack_public_path__ + "static/ab10-9da0d20871ee2029cc6bea1be4c8cccd.jpg";